import React from 'react';

type ErrorState = {
  code: number;
  message: string;
};

interface StateProps {
  loaded: boolean;
  coordinates: {
    lat?: number | null;
    long?: number | null;
  };
  error: ErrorState | boolean | null | undefined;
}

const useGeoLocation = () => {
  const [location, setLocation] = React.useState<StateProps>({
    loaded: false,
    coordinates: {
      lat: null,
      long: null,
    },
    error: null,
  });

  const onSuccess = (location: GeolocationPosition) => {
    setLocation({
      loaded: true,
      coordinates: {
        lat: location.coords.latitude,
        long: location.coords.longitude,
      },
      error: false,
    });
  };

  const onError = (error: ErrorState) =>
    setLocation((prevState) => ({ ...prevState, loaded: true, error }));

  React.useEffect(() => {
    if (!('geolocation' in navigator)) {
      onError({
        code: 0,
        message: 'Geolocation not supported',
      });
    }

    navigator.geolocation.getCurrentPosition(onSuccess, onError);
  }, []);

  return location;
};

export default useGeoLocation;
